/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Title_LanguagesInputs */

const en_resume_title_languages = /** @type {(inputs: Resume_Title_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Languages`)
};

const ar_resume_title_languages = /** @type {(inputs: Resume_Title_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اللغات`)
};

const bn_resume_title_languages = /** @type {(inputs: Resume_Title_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভাষা`)
};

const de_resume_title_languages = /** @type {(inputs: Resume_Title_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachen`)
};

const es_resume_title_languages = /** @type {(inputs: Resume_Title_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idiomas`)
};

const fr_resume_title_languages = /** @type {(inputs: Resume_Title_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langues`)
};

const pt_resume_title_languages = /** @type {(inputs: Resume_Title_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idiomas`)
};

const zh_resume_title_languages = /** @type {(inputs: Resume_Title_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言`)
};

const tr_resume_title_languages = /** @type {(inputs: Resume_Title_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diller`)
};

const ru_resume_title_languages = /** @type {(inputs: Resume_Title_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Языки`)
};

const pl_resume_title_languages = /** @type {(inputs: Resume_Title_LanguagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Języki`)
};

/**
* | output |
* | --- |
* | "Languages" |
*
* @param {Resume_Title_LanguagesInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_title_languages = /** @type {((inputs?: Resume_Title_LanguagesInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Title_LanguagesInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_title_languages(inputs)
	if (locale === "bn") return bn_resume_title_languages(inputs)
	if (locale === "de") return de_resume_title_languages(inputs)
	if (locale === "es") return es_resume_title_languages(inputs)
	if (locale === "fr") return fr_resume_title_languages(inputs)
	if (locale === "pt") return pt_resume_title_languages(inputs)
	if (locale === "zh") return zh_resume_title_languages(inputs)
	if (locale === "tr") return tr_resume_title_languages(inputs)
	if (locale === "ru") return ru_resume_title_languages(inputs)
	if (locale === "pl") return pl_resume_title_languages(inputs)
	return en_resume_title_languages(inputs)
});